<h1 mat-dialog-title>Crea un nuovo prodotto</h1>
<div mat-dialog-content>
  <form #form="ngForm">
    <mat-form-field style="width: 100%">
      <mat-label>Nome Prodotto</mat-label>
      <input type="text" name="nome"  matInput [(ngModel)]="nomeProdotto" required>
    </mat-form-field>
    <br>
    <mat-form-field>
      <mat-label>Iva</mat-label>
      <input type="number" min="0" name="iva" [pattern]="doubleFormatRegex" matInput [(ngModel)]="iva" [required]="!data">
    </mat-form-field>
    <mat-form-field style="margin-left: 50px">
      <mat-label>Prezzo(euro)</mat-label>
      <input type="string" name="prezzoCertificato" [pattern]="doubleFormatRegex" matInput [(ngModel)]="prezzo" required>
    </mat-form-field>
    <mat-form-field appearance="fill" >
      <mat-label>Tipo Prodotto*</mat-label>
      <mat-select [(ngModel)]="tipoProdotto" name="tipoProdotto">
        <mat-option value="Abbonamento">Abbonamento</mat-option>
        <mat-option value="Servizio a Consumo">Servizio a Consumo</mat-option>
        <mat-option value="Servizio Una Tantum">Servizio Una Tantum</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field style="margin-left: 30px">
      <mat-label>Durata(giorni)</mat-label>
      <input type="number" min="0" name="durataGiorni" [pattern]="doubleFormatRegex" matInput [(ngModel)]="durataGiorni" [required]="!data">
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 415px">
      <mat-label>Descrizione Estesa</mat-label>
      <textarea  matInput [(ngModel)]="descrizione" name="descrizione" rows="5" [required]="!data"></textarea>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button [disabled]="form.invalid" mat-button [mat-dialog-close]="{prezzo: this.prezzo, nomeProdotto: this.nomeProdotto,
      durataGiorni: this.durataGiorni,
      descrizione: this.descrizione,
      tipoProdotto: this.tipoProdotto,
      iva: this.iva}" (click)="onYesClick()">{{buttonText}}</button>
  <button mat-button (click)="onNoClick()">Cancella</button>
</div>
